export const siteSettings = {
  name: "Prime Pulse Capitals",
  link: "https://primepulsecaps.live",
  email: "support@primepulsecaps.live",
  appLink: "https://app.primepulsecaps.live",
};
